import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-41b054e0")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MaterialIcon = _resolveComponent("MaterialIcon")!

  return (_openBlock(), _createBlock("button", {
    class: "button",
    style: _ctx.activeColor
  }, [
    _createVNode(_component_MaterialIcon, null, {
      default: _withId(() => [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      _: 3
    })
  ], 4))
})